import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
/**
 * Helps to avoid flicker on CSR after SSR.
 * There is more details here: https://github.com/nolimits4web/swiper/issues/4186
 */
export var useSafeSwiperLoop = function useSafeSwiperLoop(children, settings) {
  var isAutoSlidesPerView = (settings === null || settings === void 0 ? void 0 : settings.slidesPerView) === 'auto';
  var _useState = useState(!!(settings !== null && settings !== void 0 && settings.loop) || !isAutoSlidesPerView),
    _useState2 = _slicedToArray(_useState, 2),
    firstOnlySlide = _useState2[0],
    setFirstOnlySlide = _useState2[1];
  useEffect(function () {
    setFirstOnlySlide(false);
  }, []);
  if (!firstOnlySlide || isAutoSlidesPerView) {
    return React.Children.toArray(children);
  }
  return React.Children.toArray(children).slice(0, (settings === null || settings === void 0 ? void 0 : settings.slidesPerView) || 1);
};